const DocumentOcrPage = ({ page, length }) => {
    return (
        <div>
            <div className="flex flex-col px-6 mb-7 break-words gap-2 rounded-md bg-base-100 ">
                <div className="break-words py-4 ">
                    <h3>Content:</h3> {page.rawOcrText}
                </div>
                <div className="flex w-100 justify-end pb-2">
                    {page.pageIndex + 1} of {length}
                </div>
            </div>
        </div>
    )
}

export default DocumentOcrPage
